/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M.2252 1.3126A.7689.7689 0 0 1 1.3126.2252L12 10.9126 22.6874.2252a.769.769 0 0 1 1.0874 1.0874L13.0874 12l10.6874 10.6874a.7689.7689 0 0 1 0 1.0874.7689.7689 0 0 1-1.0874 0L12 13.0874 1.3126 23.7748a.769.769 0 0 1-1.0874-1.0874L10.9126 12 .2252 1.3126Z"
    clipRule="evenodd"
  />,
  'Close'
);
